export var ManualCardType;
(function (ManualCardType) {
    ManualCardType["LOCAL"] = "local";
    ManualCardType["REMOTE"] = "remote";
})(ManualCardType || (ManualCardType = {}));
export var ManualCardClickAction;
(function (ManualCardClickAction) {
    ManualCardClickAction["UPLOAD"] = "upload";
    ManualCardClickAction["DOWNLOAD"] = "download";
    ManualCardClickAction["REMOVE"] = "remove";
})(ManualCardClickAction || (ManualCardClickAction = {}));
//# sourceMappingURL=manual-card-types.js.map